// 잡다 문의 메일 주소
export const JOBDA_SUPPORT_EMAIL = 'support@jobda.im';

// 피드백 구글폼
export const FEEDBACK_URL =
  'https://docs.google.com/forms/d/1sK-sg_nGN9tL-cx-9Hg2xRzBFEJJr7TmwQQn9STSZqM/viewform?edit_requested=true';

export const NCC_SUPPORT_EMAIL = 'http://pf.kakao.com/_exlxbjG';
